import {
    FETCH_ERROR, FETCH_SUCCESS, FETCH_START,
     FETCH_MONTHLY_TRANSACTION_DATA,FETCH_LOCATION_WISE_DATA
} from "../types"
import axios from "../../services/Api";

export const getMonthlyReportList = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/monthlyReport/getMonthlyReportList', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_MONTHLY_TRANSACTION_DATA, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_MONTHLY_TRANSACTION_DATA, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};